import { Component, Input } from '@angular/core';

@Component({
  selector: 'lib-provider-offers',
  templateUrl: './provider-offers.component.html',
  styleUrls: ['./provider-offers.component.css']
})
export class ProviderOffersComponent {
  @Input() offers!: string[] | undefined;
  @Input() showMoreBtn = false;
  @Input() animalId: string | null = null;

}
